/* GRIMSUPPS — mobil davranış + hareket (≤760px). Referans: GRIMSUPPS Mobil v2.dc.html */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width:760px)');
  if (!mq.matches) return;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.7,.3,1)';
  var canAnim = !!Element.prototype.animate;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var raf = function (fn) { var p = 0; return function () { if (p) return; p = requestAnimationFrame(function () { p = 0; fn(); }); }; };
  var el = function (tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };

  function stagger(list, delay, dx, dy) {
    if (!canAnim) return;
    list.forEach(function (n, i) {
      n.animate(RM ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { opacity: 1, transform: 'none' }],
        { duration: 460, delay: delay + i * 45, easing: EASE, fill: 'backwards' });
    });
  }

  /* ---------- duyuru ---------- */
  function ann() {
    var a = $('.ann'); if (!a) return;
    var items = $$('.ann > span:not(.ann__sep)', a); if (items.length < 2) return;
    a.classList.add('gs-ann'); var i = 0; items[0].classList.add('is-on');
    setInterval(function () {
      if (document.hidden) return;
      items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on');
    }, 3800);
  }

  /* ---------- header + menü ---------- */
  function header() {
    var h = $('[data-header]'); if (!h) return;
    var menu = $('[data-mobile-menu]'), root = document.documentElement, last = window.pageYOffset, hid = false;
    var menuOpen = function () { return menu && !menu.hidden; };
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset, dy = y - last; last = y;
      var nh = hid;
      if (menuOpen() || y < 90) nh = false; else if (dy > 7) nh = true; else if (dy < -7) nh = false;
      if (nh !== hid) { hid = nh; root.classList.toggle('gs-hdr-hide', hid); }
    }, { passive: true });
    if (!menu) return;
    (function () {
      var accA = $('.hdr__tools a.btn-ghost') || $('a[href*="/account"]');
      var accUrl = accA ? accA.getAttribute('href') : '/account';
      $$('a', menu).forEach(function (a) { if (/\/account/.test(a.getAttribute('href') || '')) a.classList.add('gs-hide-acc'); });
      var btns = el('div', 'gs-mbtns gs-x');
      var lg = el('a'); lg.href = accUrl; lg.textContent = 'Giriş yap';
      var sr = el('button'); sr.type = 'button'; sr.textContent = 'Ara';
      sr.addEventListener('click', function () { menu.hidden = true; var b = $('[data-menu-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); var o = $('[data-open-search]'); if (o) o.click(); });
      btns.appendChild(lg); btns.appendChild(sr); menu.appendChild(btns);
      var links = el('div', 'gs-mlinks gs-x');
      [['Kargo & Teslimat', '/pages/kargo-teslimat'], ['İade & Cayma Hakkı', '/pages/iade-cayma'], ['İletişim', '/pages/iletisim']].forEach(function (l) {
        var a = el('a'); a.href = l[1]; a.textContent = l[0]; links.appendChild(a);
      });
      menu.appendChild(links);
      menu.appendChild(el('div', 'gs-mfoot-sp gs-x'));
      var ship = getComputedStyle(document.documentElement).getPropertyValue('--free-ship').trim();
      var ft = el('div', 'gs-mfoot gs-x'); ft.textContent = (window.GS_FREE_SHIP || '750') + ' TL üzeri kargo bedava · 14 gün cayma hakkı';
      menu.appendChild(ft);
    })();
    new MutationObserver(function () {
      if (menuOpen()) {
        root.classList.remove('gs-hdr-hide'); hid = false;
        root.style.setProperty('--gs-hdr', Math.max(0, h.getBoundingClientRect().bottom) + 'px');
        root.classList.add('gs-lock');
        stagger($$(':scope > *:not(.gs-mfoot):not(.gs-mfoot-sp)', menu), 140, -18, 0);
      } else root.classList.remove('gs-lock');
    }).observe(menu, { attributes: true, attributeFilter: ['hidden'] });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) { menu.hidden = true; var b = $('[data-menu-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------- sepet sayacı ---------- */
  function badge() {
    $$('.btn-cart [data-cart-count]').forEach(function (b) {
      var prev = b.textContent.trim();
      var sync = function () {
        var v = b.textContent.trim();
        b.classList.toggle('is-zero', v === '0' || v === '');
        if (v !== prev && v !== '0') { b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 200); }
        prev = v;
      };
      sync();
      new MutationObserver(sync).observe(b, { childList: true, characterData: true, subtree: true });
    });
    var dr = $('[data-cart-drawer]');
    if (dr) new MutationObserver(function () { if (!dr.hidden) stagger($$('.dr__item', dr), 160, 0, 14); })
      .observe(dr, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* ---------- şerit okları (ortak) ---------- */
  function arrows(host, onPrev, onNext) {
    var nav = el('div', 'railnav gs-x');
    var p = el('button', 'railbtn', '&#8249;'), n = el('button', 'railbtn', '&#8250;');
    p.type = n.type = 'button'; p.setAttribute('aria-label', 'Geri'); n.setAttribute('aria-label', 'İleri');
    p.addEventListener('click', onPrev); n.addEventListener('click', onNext);
    nav.appendChild(p); nav.appendChild(n); host.appendChild(nav);
    return { prev: p, next: n };
  }

  /* ---------- vitrin ---------- */
  function hero() {
    var h = $('[data-hero]'); if (!h) return;
    /* sadece klinik seri: diyagramı olmayan (supplement) slaytlar mobilde çıkarılır */
    $$('[data-hero-slide]', h).forEach(function (s) { if (!$('.orb', s)) s.remove(); });
    var slides = $$('[data-hero-slide]', h); if (!slides.length) return;
    var numOf = function (s) { var m = /(\d+)/.exec((($('.hero__over', s) || {}).textContent || '')); return m ? +m[1] : 999; };
    slides.sort(function (a, b) { return numOf(a) - numOf(b); });
    slides.forEach(function (s) { h.appendChild(s); });
    var orig = window.__heroGo;
    var origIdx = {}; $$('[data-hero-slide]', h).forEach(function (s) { origIdx[s.getAttribute('data-handle')] = +s.getAttribute('data-hero-slide'); });
    h.classList.add('gs-hero');

    var wrap = el('div', 'gs-vwrap');
    h.parentNode.insertBefore(wrap, h);
    var head = el('div', 'gs-vhead gs-x', '<span class="gs-vhead__t">Klinik Seri</span><span class="gs-vhead__r"><span class="gs-vcount"></span></span>');
    wrap.appendChild(head); wrap.appendChild(h);
    var count = $('.gs-vcount', head);
    var btn = arrows($('.gs-vhead__r', head), function () { go(cur - 1); }, function () { go(cur + 1); });

    var thumbs = el('div', 'gs-thumbs gs-x');
    var nums = slides.map(function (s, i) { return ('0' + (i + 1)).slice(-2); });
    slides.forEach(function (s) {
      var ov = $('.hero__over', s), stg = $('.hero__stage', s);
      if (ov && stg) { var nm = (($('.buycard__name', s) || {}).textContent || '').trim(); s.insertBefore(ov, stg); }
      var bs = $('.buycard__btns .btn-solid', s); if (bs && !bs.disabled) bs.textContent = 'Sepete Ekle';
      var bl = $('.buycard .btn-line', s); if (bl) bl.textContent = 'İncele';
    });
    var ths = slides.map(function (s, i) {
      var b = el('button', 'gs-th'); b.type = 'button';
      var im = $('.pdp__bottle', s);
      b.innerHTML = (im ? '<img src="' + im.currentSrc + '" alt="" loading="lazy">' : '') + '<span>' + nums[i] + '</span>';
      if (im && !im.currentSrc) im.addEventListener('load', function () { var t = $('img', b); if (t) t.src = im.currentSrc; }, { once: true });
      b.style.setProperty('--th', (s.style.getPropertyValue('--accent') || '#242323').trim());
      b.setAttribute('aria-label', (($('.buycard__name', s) || {}).textContent || '').trim());
      b.addEventListener('click', function () { go(i); });
      thumbs.appendChild(b); return b;
    });
    wrap.appendChild(thumbs);

    var cur = -1, N = slides.length;
    function go(i, instant) { i = Math.max(0, Math.min(N - 1, i)); h.scrollTo({ left: i * h.clientWidth, behavior: instant ? 'auto' : 'smooth' }); }
    window.__heroGo = function (i, instant) {
      var hd = Object.keys(origIdx).filter(function (k) { return origIdx[k] === i; })[0];
      var k = slides.findIndex(function (s) { return s.getAttribute('data-handle') === hd; });
      go(k >= 0 ? k : i, instant);
    };

    function fitHeight() { var s = slides[Math.max(0, cur)]; if (s) h.style.height = s.offsetHeight + 'px'; }
    function setCur(i) {
      if (i === cur) return; cur = i;
      count.textContent = nums[i] + ' / ' + ('0' + N).slice(-2);
      var ac = (slides[i].style.getPropertyValue('--accent') || '#242323').trim();
      wrap.style.setProperty('--accent', ac);
      btn.prev.disabled = i === 0; btn.next.disabled = i === N - 1;
      ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var t = ths[i]; if (t) thumbs.scrollTo({ left: t.offsetLeft - thumbs.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      if (orig) orig(origIdx[slides[i].getAttribute('data-handle')], true);
      fitHeight();
    }
    var fx = raf(function () {
      var W = h.clientWidth || 1, sl = h.scrollLeft;
      setCur(Math.round(sl / W));
      slides.forEach(function (s, k) {
        var d = (k * W - sl) / W, ad = Math.abs(d); if (ad > 1.15) return;
        var b = $('.pdp__bottle', s), o = $('.orb', s), t = $('.hero__text', s);
        if (!RM && b) { b.style.translate = (d * W * 0.38).toFixed(1) + 'px 0'; b.style.rotate = (d * 6).toFixed(2) + 'deg'; }
        if (o) { if (!RM) o.style.translate = (d * W * 0.16).toFixed(1) + 'px 0'; o.style.opacity = (1 - Math.min(1, ad * 1.3)).toFixed(3); }
        if (t) { if (!RM) t.style.translate = (d * W * 0.18).toFixed(1) + 'px 0'; t.style.opacity = (1 - Math.min(1, ad * 1.6)).toFixed(3); }
      });
    });
    h.addEventListener('scroll', fx, { passive: true });
    window.addEventListener('resize', function () { fitHeight(); fx(); });
    window.addEventListener('load', fitHeight);
    setTimeout(fitHeight, 600);
    fx();
  }

  /* ---------- yatay şeritler: ok + kenarda solma ---------- */
  function rails() {
    var list = $$('[data-rail]');
    $$('.rl__grid').forEach(function (g) { g.classList.add('gs-rail'); list.push(g); });
    list.forEach(function (r) {
      var kids = function () { return Array.prototype.slice.call(r.children).filter(function (c) { return c.offsetWidth > 20; }); };
      var pad = function () { return parseFloat(getComputedStyle(r).scrollPaddingLeft) || 16; };
      var idx = function () {
        var k = kids(), p = pad(), best = 0, bd = 1e9;
        k.forEach(function (c, j) { var d = Math.abs(c.offsetLeft - p - r.scrollLeft); if (d < bd) { bd = d; best = j; } });
        return best;
      };
      var step = function (dir) {
        var k = kids(), t = k[Math.max(0, Math.min(k.length - 1, idx() + dir))]; if (!t) return;
        r.scrollTo({ left: Math.max(0, Math.min(r.scrollWidth - r.clientWidth, t.offsetLeft - pad())), behavior: 'smooth' });
      };
      var btn = null;
      var scope = r.closest('.band__in') || r.closest('.rl');
      var head = scope && (scope.querySelector('.band__head') || scope.querySelector('.rl__head'));
      if (head && !head.querySelector('[data-railnav]')) btn = arrows(head, function () { step(-1); }, function () { step(1); });
      var fx = raf(function () {
        var W = r.clientWidth, p = pad();
        kids().forEach(function (c) {
          var x = c.offsetLeft - p - r.scrollLeft, w = c.offsetWidth;
          var out = x < 0 ? Math.min(1, -x / w) : Math.max(0, Math.min(1, (x + w - (W - p)) / w));
          if (!RM) c.style.scale = (1 - out * 0.06).toFixed(3);
          c.style.opacity = (1 - out * 0.45).toFixed(3);
        });
        if (btn) {
          btn.prev.disabled = r.scrollLeft < 4;
          btn.next.disabled = r.scrollLeft > r.scrollWidth - r.clientWidth - 4;
        }
      });
      r.addEventListener('scroll', fx, { passive: true });
      window.addEventListener('resize', fx);
      setTimeout(fx, 300); fx();
    });
  }

  /* ---------- açılır kutular ---------- */
  function acc(root, head, content, open) {
    if (!root || !head || !content.length) return;
    var fold = el('div', 'gs-fold'), inn = el('div', 'gs-fold__in'), pad = el('div', 'gs-fold__pad');
    content[0].parentNode.insertBefore(fold, content[0]);
    content.forEach(function (c) { pad.appendChild(c); });
    inn.appendChild(pad); fold.appendChild(inn);
    root.classList.add('gs-acc'); if (open) root.classList.add('is-open');
    head.classList.add('gs-acc__h'); head.setAttribute('role', 'button'); head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', String(!!open));
    var toggle = function () { var on = root.classList.toggle('is-open'); head.setAttribute('aria-expanded', String(on)); };
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  }
  var after = function (n) { var out = []; while ((n = n.nextElementSibling)) out.push(n); return out; };
  function accordions() {
    $$('[data-facts-band]').forEach(function (b) {
      var hd = $('.ft__head', b);
      if (hd) acc(b, hd, after(hd), true);
    });
    $$('.usewrap__grid').forEach(function (g) { acc(g, $('.band__h2', g), $$('.uselist', g), false); });
    $$('.usage').forEach(function (u) { var b = u.parentNode; acc(b, $('.band__h2', b), [u], false); });
    $$('footer.ft .ft__cols > div').forEach(function (c) { var hd = $('.ft__head', c); if (hd) acc(c, hd, after(hd), false); });
  }

  /* ---------- arama ---------- */
  function searchUi() {
    var ov = $('[data-search-overlay]'); if (!ov) return;
    var inp = $('[data-search-input]', ov), bar = $('.ov__bar', ov), body = $('.ov__body', ov), close = $('[data-close-search]', ov);
    if (!inp || !bar || !body) return;
    var box = el('div', 'gs-qbox'); var mag = $('.mag', bar);
    bar.insertBefore(box, inp); if (mag) box.appendChild(mag); box.appendChild(inp);
    inp.placeholder = 'Formül, bileşen veya ihtiyaç';
    if (close) close.textContent = 'Vazgeç';
    var POP = ['Magnezyum', 'Omega-3', 'B12', 'HMB', 'Kreatin', 'Protein', 'Eklem'];
    var GO = [['Bağışıklık', '#CE7A12'], ['Yorgunluk & Enerji', '#C8102E'], ['Kas & Kemik', '#1B7FA0'], ['Zihinsel Fonksiyon', '#6E4293'], ['Metabolizma', '#C96A15'], ['Hormonal Denge', '#B01E24']];
    var GQ = { 'Bağışıklık': 'bağışıklık', 'Yorgunluk & Enerji': 'enerji', 'Kas & Kemik': 'kas', 'Zihinsel Fonksiyon': 'odak', 'Metabolizma': 'metabolizma', 'Hormonal Denge': 'hormonal' };
    var sq = el('div', 'gs-sq gs-x', '<div class="gs-sq__h">POPÜLER ARAMALAR</div><div class="gs-sq__chips"></div><div class="gs-sq__h gs-sq__h--2">İHTİYACA GÖRE</div><div class="gs-sq__list"></div>');
    body.insertBefore(sq, body.firstChild);
    var set = function (v) { inp.value = v; inp.dispatchEvent(new Event('input', { bubbles: true })); sync(); };
    POP.forEach(function (t) { var b = el('button'); b.type = 'button'; b.textContent = t; b.addEventListener('click', function () { set(t); }); $('.gs-sq__chips', sq).appendChild(b); });
    GO.forEach(function (g) { var b = el('button', '', '<i></i><span></span><b>&#8594;</b>'); b.type = 'button'; $('i', b).style.background = g[1]; $('span', b).textContent = g[0]; b.addEventListener('click', function () { set(GQ[g[0]] || g[0]); }); $('.gs-sq__list', sq).appendChild(b); });
    var sync = function () { ov.classList.toggle('gs-empty', !inp.value.trim()); };
    inp.addEventListener('input', sync);
    var prev = ov.hidden;
    new MutationObserver(function () {
      if (prev && !ov.hidden) {
        sync();
        if (canAnim) $('.ov__panel', ov).animate(RM ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: EASE });
        stagger($$('.gs-sq__chips button, .gs-sq__list button', sq), 120, 0, 12);
      }
      prev = ov.hidden;
    }).observe(ov, { attributes: true, attributeFilter: ['hidden'] });
    var res = $('[data-search-results]', ov);
    if (res) new MutationObserver(function () { if (!ov.classList.contains('gs-empty')) stagger($$('.res', res).slice(0, 8), 0, 0, 10); }).observe(res, { childList: true });
    sync();
  }

  /* ---------- koleksiyon satırları: ilk 6 + tümünü göster ---------- */
  function rowsMore() {
    $$('.rows').forEach(function (box) {
      var rows = $$('.row', box); if (rows.length <= 6) return;
      rows.slice(6).forEach(function (r) { r.classList.add('gs-more'); });
      var b = el('button', 'gs-showall gs-x'); b.type = 'button'; b.textContent = 'Tümünü göster · ' + rows.length;
      b.addEventListener('click', function () { var m = rows.slice(6); m.forEach(function (r) { r.classList.remove('gs-more'); }); stagger(m, 0, 0, 14); b.remove(); });
      box.parentNode.insertBefore(b, box.nextSibling);
    });
  }

  /* ---------- ihtiyaca göre: çip + panel ---------- */
  function goals() {
    var g = $('.goals'); if (!g) return;
    var cards = $$('.goal', g); if (!cards.length) return;
    var idx = []; try { idx = JSON.parse(($('[data-search-index]') || {}).textContent || '[]'); } catch (e) {}
    var bySlug = {}; idx.forEach(function (p) { bySlug[p.s] = p; });
    g.classList.add('gs-goals');
    var chips = el('div', 'gs-gchips gs-x'), panel = el('div', 'gs-gpanel gs-x');
    g.parentNode.insertBefore(chips, g); g.parentNode.insertBefore(panel, g);
    var cur = -1;
    var data = cards.map(function (c) {
      return { t: (($('.goal__t', c) || {}).textContent || '').trim(), claim: (($('.goal__claim', c) || {}).textContent || '').trim(),
        ac: (c.style.getPropertyValue('--accent') || '#242323').trim(), href: c.getAttribute('href'),
        hs: String(c.getAttribute('data-goal') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
        imgs: $$('.goal__bottle img', c).map(function (i) { return i.src; }) };
    });
    var btns = data.map(function (d, i) {
      var b = el('button', 'gs-gchip'); b.type = 'button'; b.style.setProperty('--accent', d.ac);
      b.innerHTML = '<i></i><span></span>'; $('span', b).textContent = d.t;
      b.addEventListener('click', function () { pick(i); });
      chips.appendChild(b); return b;
    });
    function fill(i) {
      var d = data[i]; panel.style.setProperty('--accent', d.ac);
      var list = d.hs.map(function (h) { return bySlug[h]; }).filter(Boolean);
      var rows = list.map(function (p) {
        return '<a class="gs-gp" href="' + p.h + '" style="--gpa:' + (p.a || '#242323') + '">' + (p.i ? '<img src="' + p.i + '" alt="">' : '<span></span>') +
          '<span><small>' + String(p.g || '').toLocaleUpperCase('tr') + '</small><b></b></span><span>' + p.p + ' →</span></a>';
      }).join('');
      if (!rows && d.href) rows = '<a class="gs-gp gs-gp--link" href="' + d.href + '"><span>Formülleri gör</span><span>→</span></a>';
      panel.innerHTML = '<div class="gs-gpanel__n">' + ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + data.length).slice(-2) + '</div><div class="gs-gpanel__c"></div><div class="gs-gpanel__list">' + rows + '</div>';
      $('.gs-gpanel__c', panel).textContent = d.claim;
      $$('.gs-gp b', panel).forEach(function (b, k) { b.textContent = list[k].t; });
    }
    var gh = g.parentNode.querySelector('.band__head');
    var ga = gh ? arrows(gh, function () { pick(Math.max(0, cur - 1)); }, function () { pick(Math.min(data.length - 1, cur + 1)); }) : null;
    if (gh) gh.classList.add('gs-ghead');
    var sx = 0, sy = 0;
    panel.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) pick(Math.max(0, Math.min(data.length - 1, cur + (dx < 0 ? 1 : -1))));
    }, { passive: true });
    function pick(i) {
      if (i === cur) return; var first = cur < 0, dir = i > cur ? 1 : -1; cur = i;
      btns.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
      if (ga) { ga.prev.disabled = i === 0; ga.next.disabled = i === data.length - 1; }
      var bb = btns[i]; if (bb) chips.scrollTo({ left: bb.offsetLeft - 16, behavior: first ? 'auto' : 'smooth' });
      panel.style.setProperty('--gdx', (dir * 18) + 'px');
      if (first) return fill(i);
      panel.classList.add('is-fade'); setTimeout(function () { fill(i); panel.classList.remove('is-fade'); }, 180);
    }
    pick(0);
  }

  /* ---------- soru kartları: ürüne git ---------- */
  function qaLinks() { $$('a.qa').forEach(function (a) { if (!$('.gs-qago', a)) a.appendChild(el('span', 'gs-qago gs-x', 'Ürüne git →')); }); }

  /* ---------- ürün sayfası: sıra ---------- */
  function pdpOrder() {
    var col = $('main .pdp__col'), st = $('main .pdp__hero [data-stage]');
    if (col && st) col.insertBefore(st, col.firstChild);
    var fb = $('[data-facts-band]'), uw = $('main .usewrap');
    if (fb && uw) { var sec = fb.closest('.shopify-section') || fb; sec.appendChild(uw); }
  }

  /* ---------- formülün hikâyesi: yatay kartlar ---------- */
  function story() {
    var host = $('[data-story-scenes]'); if (!host) return;
    var band = host.closest('[data-story-band]'), head = band && $('.st__head', band);
    var done = false;
    var build = function () {
      var kids = Array.prototype.slice.call(host.children).filter(function (c) { return c.tagName === 'DIV'; });
      if (done || !kids.length) return; done = true;
      host.classList.add('gs-story');
      var right = el('div', 'gs-x'); right.style.cssText = 'display:flex;align-items:center;gap:10px';
      var cnt = el('span', 'gs-scount'); right.appendChild(cnt); if (head) head.appendChild(right);
      var dots = el('div', 'gs-sdots gs-x'); host.parentNode.insertBefore(dots, host.nextSibling);
      var pad = 16, cur = -1;
      var go = function (i) { var k = kids[Math.max(0, Math.min(kids.length - 1, i))]; host.scrollTo({ left: k.offsetLeft - pad, behavior: 'smooth' }); };
      var bt = arrows(right, function () { go(cur - 1); }, function () { go(cur + 1); });
      right.querySelector('.railnav').classList.remove('gs-x');
      var ds = kids.map(function (k, i) { var b = el('button'); b.type = 'button'; b.setAttribute('aria-label', 'Soru ' + (i + 1)); b.addEventListener('click', function () { go(i); }); dots.appendChild(b); return b; });
      var fx = raf(function () {
        var best = 0, bd = 1e9, W = host.clientWidth;
        kids.forEach(function (k, i) {
          var x = k.offsetLeft - pad - host.scrollLeft, d = Math.abs(x); if (d < bd) { bd = d; best = i; }
          var w = k.offsetWidth, out = x < 0 ? Math.min(1, -x / w) : Math.max(0, Math.min(1, (x + w - (W - pad)) / w));
          if (!RM) k.style.scale = (1 - out * 0.06).toFixed(3); k.style.opacity = (1 - out * 0.45).toFixed(3);
        });
        if (best !== cur) {
          cur = best; cnt.textContent = ('0' + (cur + 1)).slice(-2) + ' / ' + ('0' + kids.length).slice(-2);
          ds.forEach(function (b, i) { b.classList.toggle('is-on', i === cur); });
          bt.prev.disabled = cur === 0; bt.next.disabled = cur === kids.length - 1;
        }
      });
      host.addEventListener('scroll', fx, { passive: true }); fx();
    };
    build();
    if (!done) { var mo = new MutationObserver(function () { build(); if (done) mo.disconnect(); }); mo.observe(host, { childList: true }); }
  }

  /* ---------- ürün sayfası: formül düğmesi + bileşen şeridi ---------- */
  function stageUi() {
    var st = $('main [data-stage].has-orbit'); if (!st) return;
    var nodes = $$('[data-orb-node]', st); if (!nodes.length) return;
    var n = nodes.length; st.style.setProperty('--disc', (n <= 4 ? 20 : n <= 6 ? 17 : n <= 8 ? 14 : 12) + 'vw');
    var fb = el('button', 'gs-fbtn gs-x'); fb.type = 'button';
    var label = function () { fb.textContent = st.classList.contains('is-open') ? 'Formülü kapat' : 'Formülü aç · ' + nodes.length + ' bileşen'; };
    fb.addEventListener('click', function (e) { e.stopPropagation(); st.click(); });
    $('.pdp__stage-in', st).appendChild(fb);
    var box = el('div', 'gs-chips gs-x', '<div class="gs-chips__in"><div class="gs-chips__top"><span class="gs-chips__hint"></span></div><div class="gs-chips__row"></div></div>');
    st.parentNode.insertBefore(box, st.nextSibling);
    var hint = $('.gs-chips__hint', box), row = $('.gs-chips__row', box);
    var base = nodes.length + ' bileşen · birine dokunun';
    var chips = nodes.map(function (n, i) {
      var d = $('.orb__disc', n), t = (n.getAttribute('data-label') || (($('.orb__label', n) || {}).textContent) || '').trim();
      var b = el('button', 'gs-chip'); b.type = 'button';
      var cs = d ? getComputedStyle(d) : null;
      b.innerHTML = '<i></i><span></span>'; $('span', b).textContent = t;
      if (cs) { var ic = $('i', b); ic.style.backgroundImage = cs.backgroundImage; ic.style.backgroundSize = d.style.backgroundSize || cs.backgroundSize; ic.style.backgroundPosition = d.style.backgroundPosition || cs.backgroundPosition; }
      b.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.toggle('is-on', c === b); }); hint.textContent = t;
        n.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        var L = row.scrollLeft, W = row.clientWidth, x = b.offsetLeft;
        if (x - 16 < L || x + b.offsetWidth + 16 > L + W) row.scrollTo({ left: x - 16, behavior: 'smooth' });
      });
      row.appendChild(b); return b;
    });
    var bt = arrows($('.gs-chips__top', box), function () { row.scrollBy({ left: -row.clientWidth * 0.7, behavior: 'smooth' }); }, function () { row.scrollBy({ left: row.clientWidth * 0.7, behavior: 'smooth' }); });
    bt.prev.parentNode.classList.remove('gs-x');
    var edge = raf(function () { bt.prev.disabled = row.scrollLeft < 4; bt.next.disabled = row.scrollLeft > row.scrollWidth - row.clientWidth - 4; });
    row.addEventListener('scroll', edge, { passive: true });
    var sync = function () {
      var on = st.classList.contains('is-open'); label(); box.classList.toggle('is-on', on);
      if (!on) { chips.forEach(function (c) { c.classList.remove('is-on'); }); hint.textContent = base; row.scrollLeft = 0; }
      else { stagger(chips.slice(0, 4), 120, 14, 0); setTimeout(edge, 60); }
    };
    new MutationObserver(sync).observe(st, { attributes: true, attributeFilter: ['class'] });
    hint.textContent = base; label();
  }

  /* ---------- ürün sayfası: alttaki sabit Sepete Ekle ---------- */
  function bar() {
    if (!/tpl-product/.test(document.body.className)) return;
    var form = $('main .pdp__form') || $('main form[action*="/cart/add"]'); if (!form) return;
    var add = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]:not([name="checkout"])'); if (!add) return;
    var title = ($('main h1') || {}).textContent || '';
    var img = $('main .pdp__bottle') || $('main img');
    var price = $('main [data-price]');
    var b = el('div', 'gs-bar gs-x',
      (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '<span></span>') +
      '<div style="min-width:0"><div class="gs-bar__t"></div><div class="gs-bar__p"></div></div>' +
      '<button type="button" class="gs-bar__b">Sepete Ekle</button>');
    $('.gs-bar__t', b).textContent = title.trim();
    var ac = getComputedStyle(form).getPropertyValue('--accent').trim(); if (ac) b.style.setProperty('--accent', ac);
    var bb = $('.gs-bar__b', b);
    var sync = function () { $('.gs-bar__p', b).textContent = price ? price.textContent.trim() : ''; bb.disabled = add.disabled; bb.textContent = add.disabled ? 'Tükendi' : 'Sepete Ekle'; };
    bb.addEventListener('click', function () { if (!add.disabled) add.click(); });
    document.body.appendChild(b); sync();
    if (price) new MutationObserver(sync).observe(price, { childList: true, characterData: true, subtree: true });
    new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled'] });
    var dr = $('[data-cart-drawer]');
    var check = raf(function () {
      var r = form.getBoundingClientRect(), open = dr && !dr.hidden;
      b.classList.toggle('is-on', r.bottom < 30 && !open && !document.documentElement.classList.contains('gs-lock'));
    });
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    if (dr) new MutationObserver(check).observe(dr, { attributes: true, attributeFilter: ['hidden'] });
    check();
  }

  /* ---------- kaydırınca belirme ---------- */
  function reveal() {
    if (!canAnim || !('IntersectionObserver' in window)) return;
    var SEL = '.band__h2,.rl__h2,.pcard,.row,.qa,.goal,.ccard,.rl__card,.stat,.gs-acc,.pdp__desc,.pdp__pricerow,.statband,.sec__h1,footer.ft .ft__top > div';
    var io = new IntersectionObserver(function (es) {
      var n = 0;
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var a = e.target.__gsA;
        if (a) { a.effect.updateTiming({ delay: Math.min(n++, 5) * 70 }); a.play(); a.onfinish = function () { a.cancel(); }; }
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.08 });
    var vh = window.innerHeight;
    $$(SEL).forEach(function (n) {
      if (n.closest('.hero,.hdr,.mega,.dr,.ov,.ck,.gs-bar')) return;
      var r = n.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0 && r.left < window.innerWidth && r.right > 0) return; /* ilk ekranda görünenler titremesin */
      var a = n.animate(RM ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(22px) scale(.985)' }, { opacity: 1, transform: 'none' }],
        { duration: RM ? 450 : 680, easing: EASE, fill: 'both' });
      a.pause(); n.__gsA = a; io.observe(n);
    });
  }

  function init() {
    try { ann(); } catch (e) {}
    try { header(); } catch (e) {}
    try { badge(); } catch (e) {}
    try { searchUi(); } catch (e) {}
    try { pdpOrder(); } catch (e) {}
    try { hero(); } catch (e) {}
    try { rowsMore(); } catch (e) {}
    try { goals(); } catch (e) {}
    try { qaLinks(); } catch (e) {}
    try { story(); } catch (e) {}
    try { rails(); } catch (e) {}
    try { accordions(); } catch (e) {}
    try { stageUi(); } catch (e) {}
    try { bar(); } catch (e) {}
    try { reveal(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
